import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { auth } from '@/firebase';


export default /*#__PURE__*/_defineComponent({
  __name: 'LeftNavigation',
  setup(__props) {

const naviItems = [
  { icon: 'mdi-home', title: 'Home', route: '/' },
  { icon: 'mdi-book-open-page-variant', title: 'Books', route: '/' },
  { icon: 'mdi-chat-outline', title: 'Chat', route: '/chat' },
  { icon: 'mdi-robot', title: 'Agents', route: '/' },
  { icon: 'mdi-api', title: 'APIs', route: '/' },
  { icon: 'mdi-database-edit', title: 'Knowledge', route: '/' },
  { icon: 'mdi-code-braces', title: 'Templates', route: '/templates' },
  { icon: 'mdi-brain', title: 'Models', route: '/'},
];
const miscItems = [
  { icon: 'mdi-cog', title: 'Configuration', route: '/config' },
  { icon: 'mdi-logout', title: 'Sign out', route: '/', handler: () => { console.log('sign out'); auth.signOut(); }},
  { icon: 'mdi-information', title: 'Help', route: '/about' },
];

let toggle_exclusive: any = undefined

console.log('left navigation mounted');

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    "model-value": "",
    e: "",
    class: "",
    color: "grey-lighten-3",
    permanent: "",
    rail: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, { class: "drawer-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn_toggle, { class: "btn-toggle" }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(naviItems, (naviItem) => {
                return _createVNode(_component_v_btn, {
                  key: naviItem.title,
                  class: "navi-item",
                  onClick: () => _ctx.$router.push({path: naviItem.route})
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "40",
                      title: naviItem.title,
                      icon: naviItem.icon,
                      color: "primary",
                      class: "pr-4"
                    }, null, 8, ["title", "icon"])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              }), 64)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_divider),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(miscItems, (naviItem) => {
                return _createVNode(_component_v_btn, {
                  key: naviItem.title,
                  class: "navi-item",
                  onClick: () => {_ctx.$router.push(naviItem.route); naviItem.handler? naviItem.handler(): ''}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "40",
                      title: naviItem.title,
                      icon: naviItem.icon,
                      color: "primary",
                      class: "pr-4"
                    }, null, 8, ["title", "icon"])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              }), 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})